import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
// import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
// import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
// import { InputTextModule } from 'primeng/inputtext';
// import { FieldWithLabelComponent } from 'src/app/components/field-with-label/field-with-label.component';
import { Api } from 'src/app/const/api';
import { DialogAction } from 'src/app/enums/dialog-action';
import { HttpService } from 'src/app/services/http/http.service';
import { UtilityService } from 'src/app/services/utility/utility.service';

@Component({
	selector: 'app-update-order-payment-details',
	standalone: true,
	imports: [
		// FieldWithLabelComponent,
		CommonModule,
		// ReactiveFormsModule,
		// DropdownModule,
		// InputTextModule,
		ButtonModule,
	],
	templateUrl: './update-order-payment-details.component.html',
	styleUrl: './update-order-payment-details.component.scss',
})
export class UpdateOrderPaymentDetailsComponent {
	dialogAction: DialogAction;
	// from: FormGroup;
	orderId: string;
	userTransactionID: string;

	constructor(
		private utility: UtilityService,
		private http: HttpService,
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
	) {}

	ngOnInit(): void {
		// this.from = new FormGroup({
		// 	transactionId: new FormControl('', [Validators.required]),
		// });

		const { orderId, userTransactionID } = this.dialogConfig.data;
		this.orderId = orderId;
		this.userTransactionID = userTransactionID;
	}

	// get transactionId() {
	// 	return this.from.get('transactionId');
	// }

	save() {
		// if (this.from.valid) {
		this.utility.showLoading();
		let params = {
			orderId: this.orderId,
			transactionId: this.userTransactionID,
		};
		this.http.post(Api.UPDATE_ORDER_PAYMENT_STATUS, params).subscribe({
			next: (res: any) => {
				this.closeDialog();
				this.utility.hideLoading();
				this.utility.showSuccessToast(
					"Order Payment approved. User's will be notified soon.",
				);
			},
			error: (err: any) => {
				this.utility.hideLoading();
				this.utility.showSuccessToast(
					'Something went wrong while approving order payment.',
				);
			},
			complete: () => {
				this.utility.hideLoading();
			},
		});
		// } else {
		// 	this.utility.showSuccessToast('Required fields are missing.');
		// }
	}

	closeDialog() {
		this.ref.close();
	}
}
